import React, {Component, Fragment} from 'react'
import Loader from "../../../components/common/Spinners/Loader";
import {Form, Formik} from "formik";
import * as Yup from "yup";
import {connect} from "react-redux";
import PaymentForm from "./PaymentForm";
import {
    getMyAutoPayInfo,
    enableAutoPayACH,
    enableAutoPayCC,
    enableAutoPayTokenPaymentMethod,
    getAutoPayAvailableCC,
    getMyPaymentMethods
} from "../../../actions/homeInfoActions";
import {getAccountCreditBalance} from "../../../actions/accountInfoActions";
import {getMyAmounts, getMyInvoices} from "../../../actions/homeInfoActions";
import {
    createLoadingSelector, getLoadingState,
    getPaymentProviders,
    getUserPermission,
    selectAccountInfo,
    selectHomeInfo
} from "../../../selectors";
import isEmpty, {asNoneNegative, formatAmount, trans} from "../../../utils/helpers";
import ACHForm from "./ACHForm";
import {toastr} from "react-redux-toastr";
import moment from "moment";
import {getCurrentPaymentProviderId} from "../../../actions/paymentProviderActions";
import {getCurrentPaymentProviderSupportsPaymentMethodStorage, getCurrentPaymentProviderSupportsOneTimePayment} from "../../../actions/paymentProviderActions";
import PaymentFormComponent from "./PaymentFormComponent";
import {getMyCardAmounts} from "../../../actions/getLinkedAccountInfo";
import {isNumber} from "lodash";

const PAYMENT_METHOD = {
    NONE: 'NONE',
    CREDIT_CARD: 'CC',
    ACH: 'ACH',
}

const PAYMENT_RESULT = {
    NONE: 0,
    FAIL: 1,
    SUCCESS: 2,
    GENERIC: 3,
};
const PayNowSchema = Yup.object().shape({
    paymentMethod: Yup.string()
        .required('Required'),
    paymentAmount: Yup.number()
        .required('Required')
        .transform((value, originalValue) => Number(transformAmount(originalValue)))
        .typeError('Invalid Payment Amount')
        .positive('Invalid Payment Amount')
        .test(
            'is-valid-amount',
            'Invalid Payment Amount',
            value => (value + '').match(/^(\d+\.\d{0,2}|\d+\.?|\.\d{1,2})$/gm) !== null),

});

const transformAmount = (amount) => {
    return amount.replace(/,/g, '');
}

export class PaymentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentMessage: '',
            paymentResult: PAYMENT_RESULT.NONE,
            transactionResult: null,
            achDetails: null,
            autoPayLoading: false,
            autoPayEnabled: false,
            payProviderSupportsPaymentMethodStorage: false,
            payProviderSupportsOneTimePayment: false,
            defaultPaymentMethod: null,
            paymentAmount: '',
            paymentMethod: props.currentProviderId && PAYMENT_METHOD.CREDIT_CARD,
            isSubmittingForm: false,
            autoPayInfoResults: {},
            showAutoPayButton: true,
            amountBalance: 0,
            myAmounts: null,
            isBalanceLoading: false
        };
        this.paymentFormRef = React.createRef();
    }

    componentDidMount() {
        this.initializePayment();
        this.fetchCardAmounts(this.props.accountId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.accountId !== this.props.accountId) {
            this.initializePayment();
        }
    }

    initializePayment = async () => {
        const paymentMessage = await trans('en-us', 'paymentMessage');
        this.setState({ paymentMessage });

        this.props.getAccountCreditBalance(this.props.accountId);
        this.props.getCurrentPaymentProviderSupportsPaymentMethodStorage().then(resp => {
            this.setState({ payProviderSupportsPaymentMethodStorage: resp.data.result });
            this.props.getMyPaymentMethods(this.props.accountId);
            this.props.getMyAutoPayInfo(this.props.accountId);
            this.props.getAutoPayAvailableCC(this.props.accountId);
        });
        this.props.getCurrentPaymentProviderSupportsOneTimePayment().then(resp => {
            this.setState({ payProviderSupportsOneTimePayment: resp.data.result });
            this.props.getMyPaymentMethods(this.props.accountId);
            this.props.getMyAutoPayInfo(this.props.accountId);
            this.props.getAutoPayAvailableCC(this.props.accountId);
        });
        this.props.getCurrentPaymentProviderId();

    }

    fetchCardAmounts = async (accountId) => {
        this.setState({ isBalanceLoading: true });

        try {
            const myAmounts = await getMyCardAmounts(accountId);
            this.setState({
                myAmounts: myAmounts.amounts,
                amountBalance: myAmounts.amounts.accountBalace,
                isBalanceLoading: false
            }, () => {

                this.setState({
                    paymentAmount: formatAmount(this.state.amountBalance)
                });
            });
        } catch (err) {
            this.setState({ isBalanceLoading: false });
        }
    }

    handlePaymentMethodChange = (e, values, setFieldValue, resetForm) => {
        this.setState(prevState => (prevState.paymentResult !== PAYMENT_RESULT.NONE) ? {paymentResult: PAYMENT_RESULT.NONE} : null);
        setFieldValue('paymentMethod', e.target.value);
        if (e.target.value === "MANAGE_PAYMENT_METHODS") {
            this.props.togglePanel(3)
            resetForm()
            // Wait for animation to finish
            setFieldValue('paymentMethod', "");
            setTimeout(() => {
                // Open Payment Methods Panel
                this.props.togglePanel(8)
            }, 300);
        }
    }

    // handlePaymentAmountChange = (e) => {
    //     this.setState({ paymentAmount: e.target.value });
    // }

    handlePaymentSuccess = (transactionResult) => {
        if (!isEmpty(transactionResult.result)) {
            this.setState({paymentResult: PAYMENT_RESULT.SUCCESS, transactionResult: transactionResult.result, isSubmittingForm: false});
        } else {
            this.setState({paymentResult: PAYMENT_RESULT.SUCCESS, transactionResult: transactionResult, isSubmittingForm: false});
        }
        this.props.getMyAmounts(this.props.accountId);
        this.props.getMyInvoices(this.props.accountId);
    }

    handlePaymentFail = (transactionResult) => {
        this.setState({paymentResult: PAYMENT_RESULT.FAIL, transactionResult:transactionResult, isSubmittingForm: false});

    }

    handlePaymentGeneric = (transactionResult) => {
        this.setState({paymentResult: PAYMENT_RESULT.GENERIC, transactionResult, isSubmittingForm: false});
        this.props.getMyAmounts(this.props.accountId);
        this.props.getMyInvoices(this.props.accountId);
    }

    getTransactionResultMessages = () => {
        const { transactionResult } = this.state;
        const sentences = [];

        if (transactionResult == null) {
            return sentences;
        }

        if (!isEmpty(transactionResult.responseText)) {
            sentences.push("Response: " + transactionResult.responseText + ".");
        }

        if ((!isEmpty(transactionResult.result)) && (!isEmpty(transactionResult.result.statusText))) {
            if (sentences.length > 0) {
                sentences.push(transactionResult.result.statusText);
            } else {
                sentences.push("Response: " + transactionResult.result.statusText);
            }
        }

        if (!isEmpty(transactionResult.authCode)) {
            sentences.push("Auth code: " + transactionResult.authCode + ".");
        }

        if (!isEmpty(transactionResult.transactionId)) {
            let transactionId = transactionResult.transactionId;
            if (transactionId.length > 10) {
                transactionId = "..." + transactionId.substring(transactionId.length - 10);
            }

            sentences.push("Transaction ID: " + transactionId + ".");
        }

        return sentences;
    }

    clearPaymentResult = () => {
        this.setState({paymentResult: PAYMENT_RESULT.NONE});
    }

    formatAmountWithZeroOrNegative = (amount) => {
        const parsedAmount = parseFloat(amount);
        if (isNaN(parsedAmount)) {
            return 0;
        }
        return Math.max(parsedAmount, 0);
    };

    handleSubmit = (values, { setSubmitting, setFieldValue, setFieldError, resetForm}) => {
        const { paymentMethod, paymentAmount } = values;
        const { guestOrderConfig } = window;
        const { accountInfo, creditBalance, myPaymentMethods } = this.props;
        this.setState({isSubmittingForm: true})

        if (paymentMethod === "") {
            alert("Select payment method first!")
        }
        if (paymentMethod === "ONE_TIME_PAYMENT") {
            this.props.togglePanel(3)
            // Wait for animation to finish
            setFieldValue('oneTimePayment', "");
            setTimeout(() => {
                    // Open One Time Payment Panel
                    this.props.togglePanel(10, {paymentAmount: values.paymentAmount})
                }
                , 300
            );
            resetForm()
        } else {
            toastr.confirm("To ensure a successful payment, please do not close this page until you see a confirmation message.", {
                cancelText: "Cancel",
                okText: "Proceed",
                onOk: () => {
                    this.props.getMyPaymentMethods(this.props.accountId);
                    this.setState({paymentResult: PAYMENT_RESULT.NONE, transactionResult: null});

                    const data = {
                        paymentOption: 'ALL_UNPAID_INVOICES',
                        paymentAmount: transformAmount(paymentAmount),
                        iframe: true,
                        accountId: this.props.accountId,
                    };

                    if (guestOrderConfig && guestOrderConfig.defaultLocationId) {
                        data.locationId = guestOrderConfig.defaultLocationId;
                    } else {
                        console.warn("No default location ID");
                    }

                    let usablePaymentMethod = paymentMethod
                    if ((this.state.payProviderSupportsPaymentMethodStorage) && (Object.values(PAYMENT_METHOD).includes(usablePaymentMethod)) && (!isEmpty(this.state.defaultPaymentMethod))) {
                        usablePaymentMethod = this.state.defaultPaymentMethod.token
                    }


                    if (!isEmpty(usablePaymentMethod)) {
                        if (this.paymentFormRef.current) {
                            switch (usablePaymentMethod) {
                                case PAYMENT_METHOD.CREDIT_CARD:
                                    data.paymentFormType = usablePaymentMethod;
                                    this.paymentFormRef.current.submitPaymentForm(data);
                                    break;
                                default:
                                    data.token = usablePaymentMethod
                                    this.paymentFormRef.current.submitPaymentWithToken(data);
                            }
                        } else {
                            console.error('Payment form ref is null for account:', this.props.accountId);
                            setSubmitting(false);
                        }
                    } else {
                        console.error('No usable payment method for account:', this.props.accountId);
                        setSubmitting(false);
                    }
                },
                onCancel: () => {
                    setSubmitting(false);
                }
            });
        }
    }

    storeACHDetails = (achDetails) => {
        this.setState({achDetails: {
                accountId: this.props.accountId,
                routingNumber: achDetails.routingNumber,
                accountNumber: achDetails.accountNumber,
                accountType: achDetails.accountType,
                cardHolderName: achDetails.holderName,
            }});
    };

    handleEnableAutoPay = () => {
        const {achDetails, transactionResult} = this.state;
        const {accountInfo, enableAutoPayACH, enableAutoPayCC, getMyAutoPayInfo, enableAutoPayTokenPaymentMethod} = this.props;

        // Enable AutoPay by ACH
        if (!isEmpty(achDetails)) {
            this.setState({autoPayLoading: true});

            enableAutoPayACH(achDetails).then(response => {
                this.setState({autoPayLoading: false, autoPayEnabled: true});
                getMyAutoPayInfo(this.props.accountId).then((resp) => {
                    this.setState({autoPayInfoResults: resp, showAutoPayButton: false})
                });
                toastr.success('AutoPay is now active!', { timeOut: 2000, position: 'top-center' });
            });
        }

        // Enable AutoPay by Card
        else if (!isEmpty(transactionResult)) {
            this.setState({autoPayLoading: true});

            if (!isEmpty(transactionResult.token)) {
                const info = {token: transactionResult.token, accountId:this.props.accountId};
                enableAutoPayTokenPaymentMethod(info).then(response =>{
                    this.setState({autopayUpdated: true, myAutoPayInfoLoading: 'info'}, () => {
                        this.props.getMyAutoPayInfo(this.props.accountId).then(response => {
                            this.setState({myAutoPayInfoLoading: false, autoPayInfoResults: response, showAutoPayButton: false});
                        });
                    });
                });

            } else {
                enableAutoPayCC({
                    accountId: this.props.accountId,
                    cardExpirationDate: moment(transactionResult.cardExpirationDate).format("MM/YY"),
                    cardToken: transactionResult.cardToken,
                    displayCardNumber: transactionResult.displayCardNumber,
                    type: transactionResult.paymentType,
                    cc: {
                        cardExpirationDate: moment(transactionResult.cardExpirationDate).format("MM/YY"),
                        cardToken: transactionResult.cardToken,
                        displayCardNumber: transactionResult.displayCardNumber,
                        type: transactionResult.paymentType,
                    },
                }).then(response => {
                    this.setState({autoPayLoading: false, autoPayEnabled: true});
                    getMyAutoPayInfo(this.props.accountId).then(response => {
                        this.setState({myAutoPayInfoLoading: false, autoPayInfoResults: response, showAutoPayButton: false});
                    });
                    toastr.success('AutoPay is now active!', { timeOut: 2000, position: 'top-center' });
                });
            }
        }
    }

    render() {
        const {
            paymentResult,
            autoPayLoading,
            payProviderSupportsPaymentMethodStorage,
            payProviderSupportsOneTimePayment,
            isBalanceLoading,
            myAmounts,
        } = this.state;

        const {
            currentProviderId,
            myPaymentMethodsLoader,
            myPaymentMethods,
            canMakeOneTimePayment
        } = this.props;

        const amountDue = myAmounts && myAmounts.amountDue;
        const accountBalance = myAmounts && myAmounts.accountBalace;

        if ((!isEmpty(myPaymentMethods)) && (isEmpty(this.state.defaultPaymentMethod))) {
            this.state.defaultPaymentMethod = myPaymentMethods[0];
        }


        return (
            <div className="cp-form">
                <div className="card-product">
                    <div className="card-body">

                        <p>{this.state.paymentMessage}</p>

                        {paymentResult !== PAYMENT_RESULT.SUCCESS &&
                            <div className="product-price">
                                <div className="package">
                                    <div className="package-header">

                                        <span className="package-left">Total Amount Due</span>

                                        <span className="package-right">
                                        {isBalanceLoading && <i className="fas fa-spinner fa-spin"/>}
                                            {!isBalanceLoading && '$' + formatAmount(amountDue)}
                                    </span>

                                    </div>
                                </div>
                                <div className="package">
                                    <div className="package-header">
                                        <span className="package-left">Total Balance</span>
                                        <span className="package-right">
                                        {isBalanceLoading && <i className="fas fa-spinner fa-spin"/>}
                                            {!isBalanceLoading && '$' + formatAmount(accountBalance)}
                                    </span>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.isSubmittingForm || this.state.isBalanceLoading ? (<Loader/>) : (
                            <>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        paymentMethod: '',
                                        paymentAmount: formatAmount(this.formatAmountWithZeroOrNegative(this.state.paymentAmount))
                                    }}
                                    validationSchema={PayNowSchema}
                                    onSubmit={this.handleSubmit}
                                    render={({
                                                 values,
                                                 touched,
                                                 errors,
                                                 handleChange,
                                                 handleBlur,
                                                 handleSubmit,
                                                 isSubmitting,
                                                 setFieldValue,
                                                 setValues,
                                                 setSubmitting,
                                                 setIn,
                                                 resetForm
                                             }) => (
                                        <Form
                                            onSubmit={handleSubmit}
                                            id="mainForm"
                                            autoComplete="off"
                                            className={"cmv-form" + (paymentResult === PAYMENT_RESULT.SUCCESS ? " d-none" : "")}
                                        >
                                            <div className="form-section form-section-customer-payment-content">
                                                <div className="form-section form-section-customer-payment-options">

                                                    <div className="form-row">
                                                        <div className="form-group col-sm-7">

                                                            <label>Payment Method</label>

                                                            {!payProviderSupportsPaymentMethodStorage &&
                                                                <select
                                                                    name="paymentMethod"
                                                                    value={values.paymentMethod}
                                                                    disabled={isSubmitting || !currentProviderId}
                                                                    onChange={(e) => this.handlePaymentMethodChange(e, values, setFieldValue, resetForm)}
                                                                    id="sel-customer-pmnt-method"
                                                                    className={'form-control form-control-sm' + (errors.paymentMethod && touched.paymentMethod ? ' is-invalid' : '')}
                                                                >
                                                                    <option value={PAYMENT_METHOD.CREDIT_CARD}>Debit / Credit Card</option>
                                                                    <option value={PAYMENT_METHOD.ACH}>Checking / Savings Account</option>
                                                                </select>
                                                            }
                                                            {payProviderSupportsPaymentMethodStorage && !myPaymentMethodsLoader &&
                                                                <select
                                                                    name="paymentMethod"
                                                                    value={values.paymentMethod}
                                                                    onChange={(e) => this.handlePaymentMethodChange(e, values, setFieldValue, resetForm)}
                                                                    id="sel-customer-pmnt-method"
                                                                    disabled={isSubmitting || !currentProviderId}
                                                                    className={'form-control form-control-sm' + (errors.paymentMethod && touched.paymentMethod ? ' is-invalid' : '')}
                                                                >
                                                                    <option value="" key="PLEASE_CHOOSE">Select payment method</option>
                                                                    {myPaymentMethods &&
                                                                        <>
                                                                            {myPaymentMethods.map((myPaymentMethod) => (
                                                                                <option value={myPaymentMethod.token} key={myPaymentMethod.token}>{myPaymentMethod.paymentInformation}{myPaymentMethod.autoPay ? ' (AutoPay)' : ''}</option>
                                                                            ))}
                                                                        </>
                                                                    }
                                                                    {/*{canManagePaymentMethods &&*/}
                                                                    {/*    <option value="MANAGE_PAYMENT_METHODS" key="MANAGE_PAYMENT_METHODS">Manage Payment Methods</option>*/}
                                                                    {/*}*/}
                                                                    {payProviderSupportsOneTimePayment && canMakeOneTimePayment &&
                                                                        <option value="ONE_TIME_PAYMENT" key="ONE_TIME_PAYMENT">One Time Payment</option>
                                                                    }
                                                                </select>
                                                            }

                                                        </div>

                                                        {values.paymentMethod !== PAYMENT_METHOD.ACH &&
                                                            <Fragment>
                                                                <div className="form-group col-sm-5">
                                                                    <label>Payment Amount</label>

                                                                    <div className="input-group">
                                                                        <div className="input-group-prepend">
                                                                            <span className="input-group-text">$</span>
                                                                        </div>
                                                                        <input
                                                                            type="text"
                                                                            data-type="currency"
                                                                            name="paymentAmount"
                                                                            className={'form-control' + (errors.paymentAmount && touched.paymentAmount ? ' is-invalid' : '')}
                                                                            value={values.paymentAmount}
                                                                            onBlur={handleBlur}
                                                                            placeholder={'0.00'}
                                                                            onChange={handleChange}
                                                                        />

                                                                        {errors.paymentAmount &&
                                                                            touched.paymentAmount && (
                                                                                <div className="invalid-feedback">
                                                                                    {errors.paymentAmount}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>

                                                                <div className="form-group col-12 text-right">
                                                    <span className="package-right" style={{fontSize:'0.875rem', color:'#259F52'}}>
                                                        {isBalanceLoading && <i className="fas fa-spinner fa-spin"/>}
                                                        {!isBalanceLoading && myAmounts && myAmounts.postPaymentAmount && `Payment of $${myAmounts.postPaymentAmount.toFixed(2)} is pending`}
                                                    </span>
                                                                    {paymentResult !== PAYMENT_RESULT.SUCCESS &&
                                                                        <div className="btn-group-sm">
                                                                            <button
                                                                                disabled={isSubmitting}
                                                                                type="submit" form="mainForm" className="btn btn-primary"
                                                                                id="btn-pmnt-submit"
                                                                            >
                                                                                {this.state.payProviderSupportsPaymentMethodStorage ? 'Submit Payment' : 'Continue to Pay'}
                                                                            </button>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </Fragment>}
                                                    </div>

                                                </div>
                                            </div>
                                        </Form>
                                    )}
                                />
                            </>
                        )

                        }



                        <div className={"form-section form-section-customer-payment-management" + (paymentResult === PAYMENT_RESULT.SUCCESS ? " form-section-customer-payment-management-success" : "")}>

                            {this.state.paymentMethod === PAYMENT_METHOD.CREDIT_CARD && paymentResult === PAYMENT_RESULT.NONE &&

                                <PaymentFormComponent
                                    ref={this.paymentFormRef}
                                    accountInfo={this.props.accountInfo}
                                    accountId={this.props.accountId}
                                    formTarget="payment_frame"
                                    handlePaymentSuccess={this.handlePaymentSuccess}
                                    handlePaymentFail={this.handlePaymentFail}
                                    handlePaymentGeneric={this.handlePaymentGeneric}
                                    togglePreventPanelClosing={this.props.togglePreventPanelClosing}
                                    preventPanelClosing={this.props.preventPanelClosing}
                                />
                            }

                            {this.state.paymentMethod === PAYMENT_METHOD.ACH &&
                                <ACHForm
                                    visible={paymentResult === PAYMENT_RESULT.NONE}
                                    accountBalance={accountBalance}
                                    amountDue={amountDue}
                                    currentProviderId={currentProviderId}
                                    storeACHDetails={this.storeACHDetails}
                                    handlePaymentSuccess={this.handlePaymentSuccess}
                                    handlePaymentFail={this.handlePaymentFail}
                                    handlePaymentGeneric={this.handlePaymentGeneric}
                                    togglePreventPanelClosing={this.props.togglePreventPanelClosing}
                                    preventPanelClosing={this.props.preventPanelClosing}
                                    onSubmit={() => {}}
                                />
                            }

                            {/*{(this.state.paymentMethod !== PAYMENT_METHOD.CREDIT_CARD*/}
                            {/*        && this.state.paymentMethod !== PAYMENT_METHOD.ACH*/}
                            {/*        && this.state.paymentMethod !== PAYMENT_METHOD.NONE)*/}
                            {/*    && this.state.isSubmittingForm && (*/}
                            {/*        <span>Loading</span>*/}
                            {/*    )}*/}

                            {paymentResult === PAYMENT_RESULT.SUCCESS &&
                                <div className="message">
                                    <div className="message-left">
                                        <i className="fas fa-check-circle" />
                                    </div>
                                    <div className="message-right">
                                        <h4>Payment successful</h4>
                                        {this.getTransactionResultMessages().map(msg => <Fragment><span>{msg}</span><br/></Fragment>)}
                                        <p>You'll receive details about it soon.</p>

                                        {isEmpty(this.props.myAutoPayInfo) &&  this.state.showAutoPayButton &&(
                                            <>
                                                <p>Enable AutoPay with the payment details you just used by pressing the button below!</p>
                                                <br/>
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={this.handleEnableAutoPay}
                                                    disabled={autoPayLoading}
                                                >
                                                    Enable AutoPay {autoPayLoading && <i className="fas fa-fw fa-spin fa-spinner" />}
                                                </button>
                                            </>
                                        )}

                                        {!isEmpty(this.state.autoPayInfoResults) &&
                                            <>
                                                <p>AutoPay is now active!</p>
                                            </>
                                        }

                                    </div>
                                </div>
                            }

                            {paymentResult === PAYMENT_RESULT.FAIL &&
                                <>
                                    <br/>
                                    <div className="message">
                                        <div className="message-left text-danger">
                                            <i className="fas fa-times" onClick={this.clearPaymentResult} style={{cursor: 'pointer'}}/>
                                        </div>
                                        <div className="message-right">
                                            <h4 className="text-danger">Transaction failed!</h4>
                                            {this.getTransactionResultMessages().map(msg => <Fragment><span>{msg}</span><br/></Fragment>)}
                                        </div>
                                    </div>
                                </>
                            }

                            {paymentResult === PAYMENT_RESULT.GENERIC &&
                                <>
                                    <br/>
                                    <div className="message">
                                        <div className="message-left text-muted">
                                            <i className="fas fa-info-circle" onClick={this.clearPaymentResult} style={{cursor: 'pointer'}}/>
                                        </div>
                                        <div className="message-right">
                                            <h4 className="text-muted">Transaction details</h4>
                                            {this.getTransactionResultMessages().map(msg => <Fragment><span>{msg}</span><br/></Fragment>)}
                                        </div>
                                    </div>
                                </>
                            }

                        </div>
                        {this.state.paymentMethod === PAYMENT_METHOD.CREDIT_CARD &&
                            <iframe
                                name="payment_frame"
                                frameBorder="0"
                                style={
                                    {
                                        position: 'relative',
                                        zIndex: 0,
                                        display: 'none',
                                        width: '100%',
                                        minHeight: '1530px',
                                        marginTop: '-111px',
                                        borderRadius: '0.5rem'
                                    }
                                }>
                            </iframe>
                        }

                    </div>
                </div>
            </div>
        )
    }
}

const accountCreditBalanceLoadingSelector = createLoadingSelector(['GET_ACCOUNT_CREDIT_BALANCE']);
const getMyPaymentMethodsLoader = createLoadingSelector(['MY_PAYMENT_METHODS']);

const mapStateToProps = (state) => {
    const myPaymentMethodsLoader = getMyPaymentMethodsLoader(state);
    const myPaymentMethods = selectHomeInfo(state).myPaymentMethods;
    const { accountInfo, creditBalance } = selectAccountInfo(state);
    const creditBalanceLoading = accountCreditBalanceLoadingSelector(state);
    const currentProviderId = getPaymentProviders(state).currentProviderId;
    const canManagePaymentMethods = getUserPermission(state, "API", "API_MANAGE_PAYMENT_METHODS");
    const canMakeOneTimePayment = getUserPermission(state, "BILLING", "BILLING_PAYMENT_ONE_TIME_PAYMENT");
    const loading = getLoadingState(state);


    return {
        accountInfo,
        creditBalance,
        creditBalanceLoading,
        currentProviderId,
        myPaymentMethodsLoader,
        myPaymentMethods,
        canManagePaymentMethods,
        canMakeOneTimePayment,
        loading
    };
};

const mapDispatchToProps = {
    getCurrentPaymentProviderId,
    getCurrentPaymentProviderSupportsPaymentMethodStorage: getCurrentPaymentProviderSupportsPaymentMethodStorage,
    getCurrentPaymentProviderSupportsOneTimePayment: getCurrentPaymentProviderSupportsOneTimePayment,
    getMyAmounts,
    getMyInvoices,
    getAccountCreditBalance,
    getMyAutoPayInfo,
    enableAutoPayACH,
    enableAutoPayCC,
    enableAutoPayTokenPaymentMethod,
    getAutoPayAvailableCC,
    getMyPaymentMethods,
    getMyCardAmounts
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(PaymentComponent);


